export default class DirectDebitSaveError extends Error {
  static errorType = 'DirectDebitSaveError';

  constructor(message) {
    super(message);
    this.name = DirectDebitSaveError.errorType;
  }
}
